
import { Vue, Component } from 'vue-property-decorator';

@Component({
  data() {
    return { visible: true };
  },
  props: {
    gallery: Boolean,
    header: Boolean,
  },
  computed: {
    classObject() {
      return {
        [this.$style.root]: true,
        [this.$style['--visible']]: true,
        [this.$style['--hidden']]: !this.$data.visible,
        [this.$style.gallery]: this.$props.gallery,
        [this.$style.header]: this.$props.header,
      };
    },
  },
})
export default class AnimatedSection extends Vue {}
